import { postscriptIntegrationJsonFormat } from "@redotech/redo-integrations-definitions-common/postscript-integration/postscript-integration-json-format";
import { PostscriptIntegration } from "@redotech/redo-integrations-definitions-common/postscript-integration/postscript-integration-schema-definition";
import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";

export async function getPostscriptIntegration(
  client: RedoMerchantClient,
  { signal }: { signal?: AbortSignal } = {},
): Promise<any> {
  try {
    const response = await client.client.get("support/postscript", {
      headers: client.authorization(),
      signal,
    });

    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function createPostscriptIntegration(
  client: RedoMerchantClient,
  privateApiKey: string,
  { signal }: { signal?: AbortSignal } = {},
): Promise<PostscriptIntegration | null> {
  try {
    const response = await client.client.post(
      "support/postscript",
      { data: { privateApiKey }, signal },
      { headers: client.authorization() },
    );

    return postscriptIntegrationJsonFormat.read(response.data);
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function deletePostscriptIntegration(
  client: RedoMerchantClient,
  integrationId: string,
  { signal }: { signal?: AbortSignal } = {},
): Promise<boolean> {
  try {
    const response = await client.client.delete(
      `support/postscript/${integrationId}`,
      { headers: client.authorization(), signal },
    );

    return response.status === 200 ? response.data : false;
  } catch (error) {
    console.error(error);
    return false;
  }
}

export async function setPostscriptProducts(
  client: RedoMerchantClient,
  {
    privateApiKey,
    marketing,
    support,
  }: { privateApiKey?: string; marketing?: boolean; support?: boolean },
  { signal }: { signal?: AbortSignal } = {},
): Promise<boolean> {
  try {
    const response = await client.client.put(
      "support/postscript/products",
      { data: { privateApiKey, marketing, support } },
      { headers: client.authorization(), signal },
    );
    return response.status === 200;
  } catch (error) {
    console.error(error);
    return false;
  }
}
